
import React, { Component } from 'react';
import './selectBuildPage.less';
import { Input } from "antd";
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';
import PubSub from 'pubsub-js'
import build from "../../../imgs/item/build.png";
import btn_del from "../../../imgs/btn/map_del.png";
import btn_edit from "../../../imgs/btn/btn_edit.png";
import close_btn from '../../../imgs/btn/close_btn.png';
import search from '../../../imgs/item/icon_search.png';
import { getSelectBuildingAddr, getSelectBuildingTime } from '../../../utils/meshUtils';
import { deleteCurBuilding, selectOrUpdateBuilding } from '../../../utils/net/netUtils';
import { AREA_create_build, Attention_Build, Attention_DIALOG_HIDE, Attention_DIALOG_SHOW } from '../../../const/infoConst';

let cur_build="";
let temp_selct="";
export default class SelectBuildPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            building_arr: [], //building下拉菜单
            search_info:"",
        };
    }

    componentDidMount() {
        this.updatePageUI();
        PubSub.subscribe('changeMeshUpdateUI', (msg, data) => {
            this.updatePageUI();
        })
        PubSub.subscribe(Attention_DIALOG_HIDE, (msg, index) => {
            if(index==Attention_Build && cur_build.buildingName==SPGet("delete_build_name")){
                meshLog('删除build', cur_build.buildingName);
                deleteCurBuilding(cur_build.buildingUUID);
            }  
        })
    }

    //搜索框
    searchChange= (event) => {
        let mm=event.target.value;
        meshLog('搜索',mm);
        this.setState({ search_info: mm });

        let lists = JSON.parse(SPGet("buildingList"));
        let arr=[];
        let count=0;

        for (let i = 0; i < lists.length; i++) {
            let m1=(lists[i].buildingName).toLowerCase();
            let m2=mm.toLowerCase();
            const has = m1.includes(m2);
            if(has){
                lists[i]["click"]=0;
                if(temp_selct.length>0 && m1==temp_selct){
                    lists[i]["click"]=1;
                }
                arr[count]=lists[i];
                count++;
            }
        }
        meshLog('arr', arr);
        this.setState({
            building_arr: arr,
        });
    };

    //刷新UI
    updatePageUI() {
        let lists = JSON.parse(SPGet("buildingList"));
        meshLog('获取build', lists);
        for (let i = 0; i < lists.length; i++) {
            lists[i]["click"]=0;
            if(lists[i].buildingName==SPGet("SelectBuildingName")){
                lists[i]["click"]=1;
            }
        }
        temp_selct=SPGet("SelectBuildingName");
        this.setState({
            building_arr: lists,
        });
    }

    //切换build
    buildChangeClick(build){
        cur_build=build;
        meshLog('切换build', build.buildingName);
        let lists=this.state.building_arr;
        for (let i = 0; i < lists.length; i++) {
            lists[i].click=0;
            if(lists[i].buildingName==build.buildingName){
                lists[i].click=1;
            }
        }
        temp_selct=build.buildingName;
        this.setState({
            building_arr: lists,
        });

    }

    //编辑build
    buildBtnEditClick(build){
        PubSub.publish("update_build_data_ui", build)//加载框
        this.props.onDataToParent(AREA_create_build);

    }

    //删除build
    buildBtnDeleteClick(build){
        this.buildChangeClick(build);
        SPSet("delete_build_name", build.buildingName);
        PubSub.publish(Attention_DIALOG_SHOW,Attention_Build)
    }



    //取消弹窗
    sendDataToParent(){
        this.setState({search_info:""});
        this.updatePageUI();
        this.props.onDataToParent("");
    };

    //保存弹窗
    sendDataToParentOK(){
        this.props.onDataToParent("");
        if (cur_build.buildingName == SPGet("SelectBuildingName")) return;
        selectOrUpdateBuilding(cur_build.buildingUUID,cur_build.buildingName,cur_build.companyName,cur_build.city,cur_build.address,1);
    };



    render() {
        return (
            <div className="ui_dialog_bg">
                <div className="ui_grey_bg" />
                <div className="select_build_container" style={{left:(document.body.clientWidth-380)/2}}>
                    {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={this.sendDataToParent.bind(this)}/>
                    {/* 标题行 */}
                    <div className="item_row">
                        <div className="item_title">
                            <img src={build} />
                            <span>Select Building</span>
                        </div>
                    </div>

                    {/* 搜索框 */}
                    <Input className="search_item" prefix={<img src={search} style={{ width:15, height:15 }} />} placeholder="Enter your query" value={this.state.search_info} maxLength={15} onChange={this.searchChange}/>

                    {/* Building列表 */}
                    <div className="build_list">
                        {this.state.building_arr.map((build) => (
                            <div className="build_item" key={build.buildingUUID} style={{background:build.click==1?"#f3f3f3":"#ffffff"}}>
                                <div className='m_item_name'>
                                    <span className='build_name' onClick={() => this.buildChangeClick(build)}>{build.buildingName}</span>
                                    <img className='build_btn_edit' style={{display: build.click==1?"flex":"none" }} src={btn_edit} onClick={() => this.buildBtnEditClick(build)} />
                                    <img className='build_btn_del' style={{display: (build.click==1 && this.state.building_arr.length>1 && build.buildingName!=SPGet("SelectBuildingName"))?"flex":"none" }} 
                                    src={btn_del} onClick={() => this.buildBtnDeleteClick(build)} />
                                </div>
                                <div className='m_item_time' onClick={() => this.buildChangeClick(build)}>
                                    <span className='time1'>Date Created</span>
                                    <span className='time2'>{getSelectBuildingTime(build.buildingName)}</span>
                                </div>
                                <span className='m_item_info' onClick={() => this.buildChangeClick(build)}>{getSelectBuildingAddr(build.buildingName)}</span>
                            </div>
                        ))}
                    </div>

                    {/* 底部按钮 */}
                    <div className="select_build_footer">
                        <button className='cancelBtn' onClick={this.sendDataToParent.bind(this)}>Cancel</button>
                        <button className='okBtn' onClick={this.sendDataToParentOK.bind(this)}>Confirm</button>
                    </div>


                </div>
            </div>
        );
    }
}
